import { render, staticRenderFns } from "./BenecfactorAddModal.vue?vue&type=template&id=1d5dcb86"
import script from "./BenecfactorAddModal.vue?vue&type=script&lang=js"
export * from "./BenecfactorAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports